import React from 'react';
import PropTypes from 'prop-types';
import PopupLinkInfo from './popup-link-info';
import ProductGroupPanel from './product-group-panel';
import CurrencyHelper from '../../../general/js/basket/currency-helper';
import {
    PRODUCT_TYPE_TICKET,
    PRODUCT_TYPE_HOSPITALITY,
    PRODUCT_TAG_ADULT,
    PRODUCT_TAG_YOUTH,
    PRODUCT_TAG_CAR,
    PRODUCT_TAG_JUNIOR
} from '../../../general/js/basket/constants';
import {
    SCENARIO_STANDARD,
    SCENARIO_HOSPITALITY,
    SCENARIO_HOSPITALITY_WITH_EXTRAS,
    SCENARIO_PARKING,
    SCENARIO_PARKING_STANDALONE,
    SCENARIO_STANDARD_WITH_EXTRAS
} from './constants';
import { hasValue } from '../../../general/js/general-helpers';

export default class SelectDaysForm extends React.Component {
    constructor(props) {
        super(props);
        this.formHeading = React.createRef();
        this.onSelectDay = this.onSelectDay.bind(this);
    }

    componentDidMount() {
        this.formHeading.current.focus();
    }

    onSelectDay(productGroupId) {
        let foundProductGroup = null;

        this.props.categoriesList.forEach((categorie) =>
            categorie.productGroups.forEach((productGroup) => {
                if (!foundProductGroup &&
                    productGroup.id === productGroupId
                ) {
                    foundProductGroup = productGroup;
                }
            }));

        this.props.onSelectProductGroup(foundProductGroup);
    }

    generateSummaryText(productGroup) {
        let summaryText;

        switch (this.props.currentScenario) {
            case SCENARIO_STANDARD:
                summaryText = this.generateStandardSummary(productGroup);
                break;
            case SCENARIO_HOSPITALITY:
            case SCENARIO_HOSPITALITY_WITH_EXTRAS:
                summaryText = this.generateHospitalitySummary(productGroup);
                break;
            case SCENARIO_PARKING:
            case SCENARIO_PARKING_STANDALONE:
                summaryText = this.generateParkingSummary(productGroup);
                break;
            default:
                summaryText = '';
        }

        return summaryText;
    }

    generateStandardSummary(productGroup) {
        const adultTariff = productGroup.products.find((product) =>
            product.type === PRODUCT_TYPE_TICKET && product.tag === PRODUCT_TAG_ADULT);
        const youthTariff = productGroup.products.find((product) =>
            product.type === PRODUCT_TYPE_TICKET && product.tag === PRODUCT_TAG_YOUTH);
        const juniorTariff = productGroup.products.find((product) =>
            product.type === PRODUCT_TYPE_TICKET && product.tag === PRODUCT_TAG_JUNIOR);

        const tarrifs = [];
        if (adultTariff) {
            tarrifs.push(`${CurrencyHelper.convertToPounds(adultTariff.price)} per Adult`);
        }
        if (youthTariff) {
            tarrifs.push(`${CurrencyHelper.convertToPounds(youthTariff.price)} per Youth`);
        }
        if (juniorTariff) {
            let text = 'Junior FREE';

            if (juniorTariff.price !== 0) {
                text = `${CurrencyHelper.convertToPounds(juniorTariff.price)} per Junior`;
            }

            tarrifs.push(text);
        }

        return tarrifs.join(' / ');
    }

    generateHospitalitySummary(productGroup) {
        const hospitalityTariff = productGroup.products.find((product) =>
            product.type === PRODUCT_TYPE_HOSPITALITY);
        let text = '';

        if (hospitalityTariff) {
            text += `${CurrencyHelper.convertToPounds(hospitalityTariff.price)} per person (inc VAT)`;
        }

        return text;
    }

    generateParkingSummary(productGroup) {
        const parkingTariff = productGroup.products.find((parking) =>
            parking.tag === PRODUCT_TAG_CAR);

        let text = '';

        if (parkingTariff) {
            text += `${CurrencyHelper.convertToPounds(parkingTariff.price)} ${parkingTariff.priceLabel}`;
        }

        return text;
    }

    renderCategories() {
        const categoriesList = this.props.categoriesList;

        if (!categoriesList) return null;

        return categoriesList.map((category) =>
            <div className="tb-panels-list" key={category.id}>
                <h3 className="tb-panels-list__group-heading subtitle">{category.title}</h3>
                {this.renderProductGroups(category.productGroups)}
            </div>);
    }

    renderProductGroups(productGroupsList) {
        return productGroupsList.map((productGroup) => {
            const newProductGroup = Object.assign({}, productGroup);

            newProductGroup.summaryText = this.generateSummaryText(productGroup);
            newProductGroup.isSelected = this.props.productGroupsList.some((cProductGroup) =>
                cProductGroup.id === newProductGroup.id);

            return (
                <div key={newProductGroup.id} className="tb-panels-list__item">
                    <ProductGroupPanel
                        productGroup={newProductGroup}
                        onSelect={this.onSelectDay}
                    />
                </div>
            );
        });
    }

    render() {
        return (
            <div className="tb-form">
                <h2
                    className="tb-form__heading headline"
                    tabIndex="-1"
                    ref={this.formHeading}
                >{this.props.formTitle}</h2>
                <div className="tb-form__header wo-hide-child">
                    <h3 className="title">{this.props.dictionary.selectDaysSubtitle}</h3>
                    {
                        this.props.currentScenario !== SCENARIO_STANDARD_WITH_EXTRAS &&
                        hasValue(this.props.dictionary.helpMeChooseLinkUrl) &&
                        hasValue(this.props.dictionary.helpMeChooseLinkText) &&
                            <PopupLinkInfo href={this.props.dictionary.helpMeChooseLinkUrl}>
                                {this.props.dictionary.helpMeChooseLinkText}
                            </PopupLinkInfo>
                    }
                </div>
                {this.renderCategories()}
            </div>
        );
    }
}

SelectDaysForm.propTypes = {
    dictionary: PropTypes.object.isRequired,
    product: PropTypes.object,
    productGroupsList: PropTypes.array,
    categoriesList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    formTitle: PropTypes.string,
    onSelectProductGroup: PropTypes.func
};
